import type { ComponentProps } from 'react';

import { TextAreaField as UadTextAreaField } from '@iconik-io/uad';

type UadTextAreaFieldProps = ComponentProps<typeof UadTextAreaField>;

import { useFieldContext } from '../app_form_context';
import { getFieldErrorMessage } from '../get_field_error_message';

export type TextAreaFieldProps = Omit<
  UadTextAreaFieldProps,
  'name' | 'value' | 'onChange' | 'onBlur' | 'isInvalid' | 'errorMessage'
>;

export function TextAreaField(props: TextAreaFieldProps) {
  const field = useFieldContext<string>();
  const isInvalid = field.state.meta.isTouched && !field.state.meta.isValid;

  return (
    <UadTextAreaField
      name={field.name}
      value={field.state.value}
      onBlur={field.handleBlur}
      onChange={field.handleChange}
      isInvalid={isInvalid}
      errorMessage={
        isInvalid ? getFieldErrorMessage(field.state.meta.errors) : undefined
      }
      {...props}
    />
  );
}
